/** An address inside this dashboard: starts with a single slash, and not a
 * double slash or a backslash (which browsers treat as a slash), so it can
 * never point at another site. */
const SAFE_PATH = /^\/(?![/\\])[^\\]*$/;
/** `value` if it is an address inside this dashboard, otherwise '/'. Also
 * refuses the percent-encoded backslash, and control characters that
 * browsers strip, which can turn `/\t/evil.example` into `//evil.example`. */
export function safeNextPath(value) {
    if (typeof value !== 'string' || !SAFE_PATH.test(value))
        return '/';
    // eslint-disable-next-line no-control-regex
    if (/[\u0000-\u001f\u007f]/.test(value))
        return '/';
    let decoded = value;
    try {
        decoded = decodeURIComponent(value);
    }
    catch {
        return '/';
    }
    return SAFE_PATH.test(decoded) ? value : '/';
}
